import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, PlaceholderLoader, Table } from '../index.js';
import { getDescriptor } from './registries.js';
const StatusModal = (props) => {
    const { status, registry } = props;
    const lang = useSelector((s) => s.lang);
    const descriptor = getDescriptor(registry);
    const rows = status !== null ? descriptor.statusRows(status) : [];
    return (React.createElement(Modal, { header: descriptor.statusHeader(lang), onToggle: props.toggleStatusModal, maxWidth: "600px" }, status !== null ? (React.createElement(Table, { zebra: true }, rows.map((entry) => (React.createElement("tr", { key: entry[0] },
        React.createElement("td", null, entry[0]),
        React.createElement("td", null,
            React.createElement("b", null, entry[1]))))))) : (React.createElement(PlaceholderLoader, null))));
};
export default StatusModal;
//# sourceMappingURL=StatusModal.js.map